import { Skeleton } from "@mui/material";

const Loader = ({ count = 3 }) => {
  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Skeleton variant="text" width="30%" height={35} />
        <Skeleton variant="rectangular" width={100} height={40} />
      </div>

      {[...Array(count)].map((_, index) => (
        <div
          key={index}
          className="border rounded p-3 mb-4 shadow-sm"
          style={{ backgroundColor: "#fff" }}
        >
          <Skeleton variant="text" width="40%" height={25} className="mb-3" />

          <div className="row g-3">
            <div className="col-12 col-sm-6">
              <Skeleton variant="text" width="100%" height={20} />
            </div>
            <div className="col-12 col-sm-6">
              <Skeleton variant="text" width="100%" height={20} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Loader;
